import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const sizes = [0, 4, 8, 12, 16, 20, 24, 32, 36, 40, 48, 64, 80] as const;

export type TListSize = typeof sizes[number];

type TListSizeProps = {
    $size: TListSize,
    $desktop?: never,
    $mobile?: never,
} | {
    $size?: never,
    $desktop: TListSize,
    $mobile: TListSize,
}

type TAlign = CSSProperties['alignItems'];
type TJustify = CSSProperties['justifyContent'];

export type TListProps = {
    $direction?: 'column' | 'row',
    $reverse?: boolean,
    $wrap?: 'wrap' | 'wrap-reverse' | 'nowrap',
    $justifyContent?: TJustify,
    $alignItems?: TAlign,
} & TListSizeProps;

const getGapBySizeProps = ({ $size, $desktop, $mobile }: TListProps) => {
    if (typeof $size !== 'undefined') {
        return css`
            gap: ${() => `${$size}px`};
        `;
    } else {
        return css`
            gap: ${() => `${$mobile}px`};
            
            @media (min-width: ${wideBreakpoints.mobile}) {
                gap: ${() => `${$desktop}px`};
            }
        `;
    }
};

const ListContainer = styled.div<TListProps>`
    display: flex;
    
    margin: 0;
    padding: 0;
    
    ${({ $direction = 'row', $reverse = false, $wrap = 'wrap', $justifyContent = 'normal', $alignItems = 'normal' }) => css`
        flex-direction: ${$direction}${$reverse ? '-reverse' : ''};
        flex-wrap: ${$wrap};
        justify-content: ${$justifyContent};
        align-items: ${$alignItems};
    `}
    
    ${getGapBySizeProps}
`;

export default ListContainer;
